import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="appointment-scheduler"
export default class extends Controller {
  static targets = [
    "networkSection",
    "providerAddress",
    "month",
    "day",
    "year",
    "hour",
    "minute",
    "ampm"
  ]
  static values = {
    lookupUrl: String
  }

  useCurrentTime(event) {
    event.preventDefault()
    const now = new Date()

    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")
    const year = String(now.getFullYear())

    let hour24 = now.getHours()
    const ampm = hour24 >= 12 ? "PM" : "AM"
    let hour12 = hour24 % 12
    if (hour12 === 0) hour12 = 12

    // Minute <select> only offers 00/15/30/45 — snap to the nearest option.
    const quarters = [0, 15, 30, 45]
    const nearest = quarters.reduce((best, q) => (
      Math.abs(now.getMinutes() - q) < Math.abs(now.getMinutes() - best) ? q : best
    ), quarters[0])
    const minute = String(nearest).padStart(2, "0")

    this.monthTarget.value = month
    this.dayTarget.value = day
    this.yearTarget.value = year
    this.hourTarget.value = String(hour12)
    this.minuteTarget.value = minute
    this.ampmTarget.value = ampm
  }

  onProviderSelected(event) {
    const npi = event.target.value

    if (npi && npi.match(/^\d{10}$/)) {
      this.lookupNetwork(npi)
    } else {
      this.networkSectionTarget.innerHTML = ''
      this.providerAddressTarget.value = ''
    }
  }

  async lookupNetwork(npi) {
    const url = `${this.lookupUrlValue}?npi=${npi}`

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        const html = await response.text()
        // Turbo stream will handle the update
        Turbo.renderStreamMessage(html)

        // Update hidden provider address from the response
        const providerInfo = this.networkSectionTarget.querySelector('[data-provider-address]')
        if (providerInfo) {
          this.providerAddressTarget.value = providerInfo.dataset.providerAddress || ''
        }
      }
    } catch (error) {
      console.error("Error looking up network:", error)
    }
  }

}
